/**
 * Shift-register endpoints (bos-api).
 *
 * Relative to the axios client's base, which already ends in `/api/v1` — so
 * `/shifts` reaches `…/api/v1/shifts`.
 *
 * **These are not the till's shift endpoints.** `/shifts/current`,
 * `/shifts/expected`, `/shifts/open` and `/shifts/close` sit behind a PIN-only
 * policy and belong to the POS; bos-app cannot call them and does not model
 * them. The two paths here are the back-office pair, served by a separate
 * controller under the same prefix and gated on `BranchAdmin` instead.
 */

export const ShiftsEndpoints = {
    /** GET — the paged shift register, newest first. */
    register: () => '/shifts',
    /** GET — one shift's ledger rollup, net of reversals. */
    ledgerSummary: (shiftId: string) =>
        `/shifts/${encodeURIComponent(shiftId)}/ledger-summary`,
};
